import React, { useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import useDocumentTitle from '../components/useDocumentTitle';
import { OBSERVATORYLINK } from '../config';

const Observatory = () => {
    useDocumentTitle("Observatorio Inmobiliario");

    useEffect(() => {
        const win = window.open(OBSERVATORYLINK, "_blank");
        win.focus();
    }, []);

    return (
        <div>
            <PageHeader tittle="OBSERVATORIO INMOBILIARIO" />
            <div className='md:px-5 px-1'>
                <div className='flex flex-col w-full'>
                    {/* La pagina que intentas acceder no existe, por favor verifica la url o vuelve al inicio. */}
                    <p className='text-center sm:w-[50%] py-6 mx-auto text-2xl sm:text-3xl font-light'>La vista del Observatorio Inmobiliario se ha mostrado en una nueva pestaña para mayor comodidad. por favor diríjase a ella.</p>
                    <p className='text-center sm:w-[50%] py-6 mx-auto text-2xl sm:text-3xl font-light'>En caso contrario, <a target='_BLANK' className='text-blue-800 underline' href={OBSERVATORYLINK} >click Aquí.</a></p>
                </div>
            </div>
        </div>
    );
}

export default Observatory;